// Data.
import isActive, { activityTypes, loggedInUser, postAuhor, currentPostId, getCurrentWidgetsSidebar } from './utils';

export default {
	isActive,
	activityTypes,
	loggedInUser,
	postAuhor,
	currentPostId,
	getCurrentWidgetsSidebar,
};
